module.exports = __webpack_public_path__ + "static/media/excelPicklist1.b83eb11a.png";